"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWaitForCondition = exports.waitForCondition = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("./utils");
const errors_1 = require("./errors");
const waitForCondition = (predicate, paramsOrCustomErrorMessage) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const params = (0, utils_1.buildParamsWithDefaults)(paramsOrCustomErrorMessage);
    let timeLeft = params.timeout;
    while (timeLeft > 0) {
        const startTime = Date.now();
        try {
            if ((yield predicate()) === true) {
                return;
            }
        }
        catch (error) {
            throw (0, errors_1.createPredicateExecutionError)(error);
        }
        yield params.delayFn(params.interval);
        const actualTimePassed = Date.now() - startTime;
        timeLeft -= actualTimePassed;
    }
    throw (0, errors_1.createTimeoutError)(predicate, params.errorMessage);
});
exports.waitForCondition = waitForCondition;
const createWaitForCondition = (config) => {
    const { predicateTransform } = config, params = tslib_1.__rest(config, ["predicateTransform"]);
    return (predicate, paramsOrCustomErrorMessage) => (0, exports.waitForCondition)(predicateTransform ? predicateTransform(predicate) : predicate, Object.assign(Object.assign({}, params), (0, utils_1.parseCustomParams)(paramsOrCustomErrorMessage)));
};
exports.createWaitForCondition = createWaitForCondition;
//# sourceMappingURL=waitForCondition.js.map